





























































import FleetManagerTreeDialog from "@/components/fleet/FleetManagerTreeDialog.vue";
import ErrorCard from "@/components/utility/ErrorCard.vue";
import MHeader, { IAction } from "@/components/utility/mmmint/MHeader.vue";
import LayoutReport from "@/layouts/LayoutReport.vue";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { PartnerColor } from "@/lib/partnerColor";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { FleetManagerModule } from "@/store/modules/fleet/manager-fleet.store";
import { UserModule } from "@/store/modules/me-user.store";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    LayoutReport,
    ErrorCard,
    FleetManagerTreeDialog,
    MHeader
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class FleetHomeView extends Vue {
  loading = false;
  isError = false;
  openNodes: string[] = [];

  get selectedFleetIds() {
    return FleetManagerModule.selectedFleetIds ?? [];
  }

  set selectedFleetIds(selected: string[]) {
    FleetManagerModule.setSelectedFleetIds(selected);
  }

  get actions(): IAction[] {
    return [
      {
        text: this.$t("views.report.fleet.FleetAnalyticsView.selectionDialog.openFleetTree").toString(),
        key: "fleet",
        exec: () => ((this.$refs.dialog as unknown) as IDialog)?.open()
      }
    ];
  }

  get breadCrumbs(): IBreadcrumb[] {
    const breadCrumbs: IBreadcrumb[] = [];

    breadCrumbs.push({
      text: this.$t("nav.FleetTableView.description"),
      disabled: true,
      exact: true,
      to: {
        name: "FleetHomeView",
        params: {}
      }
    });

    return breadCrumbs;
  }

  get fleetId() {
    return FleetManagerModule.selectedFleetId;
  }

  get fleetIds() {
    return UserModule.fleetPermission?.filter(p => p.partnerId === this.partnerId).map(p => p.fleetId);
  }

  get partnerId() {
    return ReportModule.partner.id;
  }

  get fleetTree() {
    return FleetManagerModule.fleetTree;
  }

  get fleetIdList() {
    return UserModule.fleetPermission?.filter(p => p.partnerId === this.partnerId).map(p => p.fleetId) ?? [];
  }

  get uniqueFleetIds() {
    const fleetIds = new Set();

    this.fleetIdList.forEach(i => fleetIds.add(i));

    return fleetIds.values();
  }

  get uniqueFleetCount() {
    return Array.from(this.uniqueFleetIds).length;
  }

  get partnerColor() {
    return new PartnerColor();
  }

  get title() {
    return `${this.$t("report.thgOverview.title")}  ${UserModule.user.firstName} ${UserModule.user.lastName} ☀️`;
  }

  get description() {
    return this.$t("report.thgOverview.description");
  }

  get chips(): IAction[] {
    const chips: IAction[] = [];

    if (this.uniqueFleetCount > 1) {
      chips.push({
        text: `${this.uniqueFleetCount} ${this.$t("views.fleet.FleetHomeView.fleetTrees")}`,
        key: "fleet-tree",
        icon: "mdi-family-tree"
      });
    }

    chips.push(
      ...[
        {
          text: this.$t("views.fleet.FleetHomeView.selectedFleets", { n: this.selectedFleetIds.length }).toString(),
          key: "fleet",
          icon: "mdi-car-multiple"
        }
      ]
    );

    return chips;
  }

  get navItems() {
    return [
      {
        title: "report.thgVehicleOverview.title",
        isEnabled: true,
        items: [
          {
            title: "report.thgOverview.vehicle.overview",
            click: () => this.$router.push({ name: "FleetVehicleView" }),
            src: "https://static.mmmint.ai/wirkaufendeinethg/parkplatz-1.jpeg",
            isEnabled: true
          }
        ].filter(x => x.isEnabled)
      },
      {
        title: "navigation.ThePartnerList.report",
        isEnabled: true,
        items: [
          {
            title: "navigation.ThePartnerList.report",
            click: () => this.$router.push({ name: "FleetDamageView" }),
            src: "https://static.mmmint.ai/app/contact/kontaktformular.jpeg",
            isEnabled: true
          }
        ].filter(x => x.isEnabled)
      },
      {
        title: "report.thgOverview.other",
        isEnabled: true,
        items: [
          {
            title: "report.thgOverview.billing",
            click: () => this.$router.push({ name: "FleetInvoiceView" }),
            src: "https://static.mmmint.ai/wirkaufendeinethg/thg-overview-contact-cash-1.jpeg",
            isEnabled: true
          },
          {
            title: "common.nouns.analytics",
            click: () => this.$router.push({ name: "FleetAnalyticsView" }),
            src: "https://static.mmmint.ai/wirkaufendeinethg/insurance-check-1.jpeg",
            isEnabled: true
          }
        ].filter(x => x.isEnabled)
      }
    ].filter(x => x.isEnabled);
  }

  async load(fleetId: string) {
    this.loading = true;

    try {
      return FleetManagerModule.getFleetTree({ partnerId: this.partnerId, fleetId: fleetId });
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }
}
